import CardStyles from "./Card.module.css";

export default function CardContainer({ children }) {
	return <div className={CardStyles["card-container"]}>{children}</div>;
}
